export default "__VITE_ASSET__db198c3e__"